export default "__VITE_ASSET__6_50HioD__"